module.exports = __webpack_public_path__ + "static/media/pattern-blow.90f2e80e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-blow.svg
// module id = 1270
// module chunks = 37